import React, {useEffect, useState} from 'react';
import { Col, Row } from 'reactstrap';
import {connect, useSelector} from "react-redux";


// components

// actions
import {
    ADD_STATE, REMOVE_STATE, setUdn, setApp, setItem, setForm
} from "../../../redux/actions/generics/IndexedActions";

// utils
import DestinationActivityForm from "./_form";
import {getStateByPath} from "../../../redux/selectors";
import {GenericContainer} from "../../../components/containers/GenericContainer";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {destinationActivityService} from "../../../jwt/_services/xailing/destinationActivityService";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import TranslateButton from "../../../components/buttons/TranslateButton";


const DestinationActivity = props => {
    const path = `${props?.path}/activity`;

    const parentComponentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const { app, udn, domainObject } = parentComponentState?.data || {};
    const { loading } = componentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];

    const [showFormModal, setShowFormModal] = useState(false);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (udn !== null)
            props.setUdn(path, udn);

        if (app !== null)
            props.setApp(path, app);
    },[]);

    useEffect(() => {
        if (!app)
            return

        const dataRequest =  {
            onlyRegistered: true,
            fbDataBase:{ id: app?.fbDataBase?.id},
            item: {
                destination: { id: domainObject.id }
            }
        }

        genericIndexedActions.search(path, destinationActivityService, 0, 1000, dataRequest)
    }, [ app ]);

    const onCreateItem = () => {
        props.setItem(path, null);
        props.setForm(path)
        setShowFormModal(!showFormModal);
    }

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false)
        setShowFormModal(!showFormModal)
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: destinationActivityService,
        remove : genericIndexedActions.delete,
    } );

    const onReorder = ({list:reorderedItems}) => {
        const items = []

        for (const reorderedItem of reorderedItems) {
            const {id, showOrder} = reorderedItem

            const item = listDomainObjects.find(item => item.id === id)

            if(item?.showOrder !== showOrder)
                items.push({id, showOrder})
        }

        let requestData = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items
        }

        genericIndexedActions.reorder(path, destinationActivityService, requestData)
    }

    const renderContent = (item, index) => <div key={index} className={'dnd-item'}>
        <Row>
            <Col className={'dnd-title'}>
                {item.title}
            </Col>
            <Col>
                <div className={'actions'}>
                    <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(item)}/>
                    <TranslateButton item={item} service={destinationActivityService} path={path}/>
                    <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(item)}/>
                </div>
            </Col>
        </Row>
    </div>

    return <>
        <GenericContainer
            titlle={'Actividades'}
            listItems={listDomainObjects}
            renderContent={renderContent}

            onCreateItem={onCreateItem}
            onReorderItems={onReorder}

            loading={loading}
        />
        {
            showFormModal && <DestinationActivityForm
                path={props?.path}
                isOpen={showFormModal}
                toggle={() => setShowFormModal(!showFormModal)}
            />
        }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn, setApp,
    setItem,
    setForm
})

export default connect(mapStateToProps, mapActionsToProps)(DestinationActivity);